// extracted by mini-css-extract-plugin
module.exports = {"HoverDialog":"Utilities_HoverDialog__RmIez"};